// @ts-nocheck
import dom from "../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import classNames from "classnames";
import CitationButton from "../common/components/CitationButton.jsx";
import CopyButton from "../common/components/CopyButton.jsx";
import {ShadowContent} from "../common/components/ShadowElements.jsx";
import {COMMENT_MENU_JS_SELECTOR} from "../comment-menu.js";
import RichTextEditor from "../common/components/RichTextEditor.jsx";
import IconButton from "../common/components/IconButton.jsx";

/**
 * @param {Object}   props
 * @param {Object}   props.annotation
 * @param {boolean}  props.editable
 * @param {boolean}  props.isSaving         panel is shown for new annotations before they're saved in the DB, with buttons disabled.
 * @param {function} props.onClickCitation
 * @param {function} props.onClickCopy
 * @param {function} props.onClickDelete
 * @param {function} props.onClickHeader
 * @param {function} props.onClickSave      async function. This is called with the user's notes as the sole parameter.
 * @param {function} props.onKeyDownHeader
 * @param {Object}   props.topic
 * @param {number}   props.top
 * @param {number}   props.left
 * @return {HTMLElement}
 */
const CommentMenuPanel = props => {
	const {editable, onClickDelete, onClickSave} = props;
	const onClickHeader = editable ? props.onClickHeader : undefined;
	const handleSave = () => {
		onClickSave().then(); // async call
	};

	// TODO: .js-btn-comment-menu-header is still referenced by ws-sync/topic-change.js

	return (
		<ShadowContent
			data-is-saving={props.isSaving ? "true" : "false"}
			id="comment-menu"
			role="dialog"
			style={{
				position: "absolute",
				top:      props.top + "px",
				left:     props.left + "px"
			}}
		>
			<div
				className={classNames("js-comment-header", "comment-header", {
					"editable": editable
				})}
				style={{borderTopColor: "#" + props.topic.color}}
			>
				<HeaderTopicButton
					color={props.topic.color}
					label={props.topic.label}
					onClick={onClickHeader}
					onKeyDown={props.onKeyDownHeader}
					disabled={props.isSaving}
				/>
			</div>

			<RichTextEditor
				id="comment-menu"
				isAnnotationNote={true}
			/>

			<div className="comment-footer">
				{editable && <IconButton
					className="aa-btn-ext-icon btn-delete js-btn-delete"
					disabled={props.disabled}
					icon="aa-icon-trash"
					onClick={onClickDelete}
					showToolTip={false} // This tooltip is initialialized in comment-menu.js
					tooltipText="Delete"
				/>}
				<CopyButton
					onClick={props.onClickCopy}
					addTippyAttr={true}
				/>
				<CitationButton
					annotation={props.annotation}
					disabled={props.isSaving}
					isEditable={editable}
					isSidebarApiClosed={props.isSidebarApiClosed}
					onClickCitation={props.onClickCitation}
					showToolTip={false} // This tooltip is initialialized in comment-menu.js
				/>

				<IconButton
					className="aa-btn-ext-icon btn-done"
					disabled={props.disabled}
					icon="aa-icon-confirm aa-icon-mask"
					onClick={handleSave}
					showToolTip={false} // This tooltip is initialialized in comment-menu.js
					tooltipText="Done"
				/>
			</div>
		</ShadowContent>
	);
};

/**
 * @param {Object} props
 * @param {string} props.color
 * @param {string} props.label
 * @param {function} props.onClick
 * @param {function} props.onKeyDown
 * @param {boolean} props.disabled
 */
export const HeaderTopicButton = (props) => {
	const button = <button
		className="btn-topic-name js-btn-comment-menu-header"
		lang=""
		style={{color: "#" + props.color}}
		onClick={props.onClick}
		onKeyDown={props.onKeyDown}
	>{props.label}</button>;

	if (props.disabled)
		button.disabled = true;

	return button;
};

/**
 * Citation data is retrieved async when creating new annotations,
 * so it may not be available when the comment menu is rendered.
 * This function allows us to update the button when the data
 * becomes available. This is mostly so the icon can be rendered
 * to indicate citation approval if the citation logic gives us
 * a citation that's already approved.
 *
 * @param {Object}   annotation
 * @param {boolean}  editable
 * @param {function} onClickCitation
 */
export const updateCitationButton = (annotation, editable, onClickCitation) => {
	const oldBtn = document.querySelector(COMMENT_MENU_JS_SELECTOR).shadowRoot.querySelector(".js-aa-citation-btn");
	if (oldBtn) {
		const newBtn = <CitationButton
			annotation={annotation}
			isEditable={editable}
			onClickCitation={onClickCitation}
			showToolTip={false}
		/>;

		oldBtn.replaceWith(newBtn);
	}
};

/**
 * This component is used for copying text data to the user's clipboard.
 *
 * @param {Object} props
 * @param {string} props.text
 */
export const DummyTextarea = (props) => {
	const style = {
		position: "absolute",
		top:      "-1000px",
		left:     "-1000px"
	};

	return (
		<textarea
			style={style}
		>{props.text}</textarea>
	);
};

export default CommentMenuPanel;
